import { useTheme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles";

export const useAnnualWheelSubTasksStyles = () => {
    const theme = useTheme();

    return createSxStyles({
        // The drag handle takes the room the other lists use as left padding.
        row: {
            gap: theme.spacing(0.5),
            paddingLeft: theme.spacing(0.5),
        },
        draggingRow: {
            backgroundColor: theme.palette.primary.light,
            borderRadius: "10px",
        },
        dragHandle: {
            display: "flex",
            visibility: "hidden",
        },
        hidden: {
            display: "none",
        },
        dragIcon: {
            fill: theme.palette.grey[500],
            height: 20,
            outline: "none",
            "&:hover": {
                cursor: "grab",
            },
        },
    });
};
